export const COVERAGE_VIEW_SEARCH_PARAM = "coverageView";

export type CoverageBuilderView = "about" | "configure";

export function parseCoverageBuilderView(
  searchParams: URLSearchParams,
): CoverageBuilderView | undefined {
  const view = searchParams.get(COVERAGE_VIEW_SEARCH_PARAM);
  return view === "about" || view === "configure" ? view : undefined;
}

export function resolveInitialCoverageBuilderView({
  hasSavedCoverageStep,
  requestedView,
  skipAbout,
}: {
  hasSavedCoverageStep: boolean;
  requestedView: CoverageBuilderView | undefined;
  skipAbout: boolean;
}): CoverageBuilderView {
  if (skipAbout) {
    return "configure";
  }
  if (requestedView) {
    return requestedView;
  }
  return hasSavedCoverageStep ? "configure" : "about";
}

export function withCoverageBuilderView(
  search: string,
  view: CoverageBuilderView,
): string {
  const searchParams = new URLSearchParams(search);
  searchParams.set(COVERAGE_VIEW_SEARCH_PARAM, view);
  return `?${searchParams.toString()}`;
}
